// Blog yazılarının indeksi - sadece temel bilgileri içerir
export const blogIndex = {
  "sosyal-medyada-idealize-edilmis-hayatlar": {
    id: 8,
    slug: "sosyal-medyada-idealize-edilmis-hayatlar",
    title: "Sosyal Medyada İdealize Edilmiş Yaşamlar ve Psikolojik Etkileri",
    date: "10 Mart 2026",
    author: "Yağmur Demiröz",
    image: "/sosyal-medya-ve-psikoloji.jpeg",
    excerpt: "Sosyal medya hayatımızın ayrılmaz bir parçası hâline geldi. Paylaşılan fotoğraflar ve hikâyeler çoğunlukla insanların hayatlarının en 'kusursuz' anlarını yansıtır. Bu idealize edilmiş içerikler psikolojimizi nasıl etkiliyor?",
    filePath: "./blog-posts/sosyal-medyada-idealize-edilmis-hayatlar.js",
  },
  "terapi-turleri-nelerdir": {
    id: 7,
    slug: "terapi-turleri-nelerdir",
    title: "Terapi Türleri Nelerdir? Hangi Psikoloğa Gitmeliyim?",
    date: "4 Şubat 2026",
    author: "Yağmur Demiröz",
    image: "/terapi-turleri.jpeg",
    excerpt: "Terapi sürecine başlamaya karar verdiğimiz andan itibaren zihnimizde birçok soru oluşur: 'Hangi terapi benim için uygun?', 'Hangi psikoloğa gitmeliyim?'...",
    filePath: "./blog-posts/terapi-turleri-nelerdir.js",
  },
  "terapi-sureci": {
    id: 6,
    slug: "terapi-sureci",
    title: "Terapi Süreci",
    date: "14 Aralık 2025",
    author: "Yağmur Demiröz",
    image: "/terapi-sureci.jpg",
    excerpt: "Terapi süreci, kişinin kendisini daha yakından tanımaya başladığı; duygu, düşünce ve davranışlarını anlamlandırdığı, iç dünyasına dair farkındalık kazandığı bir yolculuktur...",
    filePath: "./blog-posts/terapi-sureci.js",
  },
  "okula-uyum-surecinde-cocuklari-desteklemek": {
    id: 5,
    slug: "okula-uyum-surecinde-cocuklari-desteklemek",
    title: "Okula Uyum Sürecinde Çocukları Desteklemek: Ebeveynler İçin Öneriler",
    date: "25 Ağustos 2025",
    author: "Yağmur Demiröz",
    image: "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=800&auto=format&fit=crop",
    excerpt: "Eylül ayı, birçok çocuk için yeni bir başlangıç anlamına gelir. Okula uyum sürecinde ebeveynlerin tutumu kritik bir rol oynar...",
    filePath: "./blog-posts/okula-uyum-surecinde-cocuklari-desteklemek.js",
  },
  "hizli-tuketilen-iliskiler": {
    id: 4,
    slug: "hizli-tuketilen-iliskiler",
    title: "Hızlı Tüketilen İlişkiler: Günümüz Bağlılık Dinamikleri",
    date: "1 Mart 2025",
    author: "Yağmur Demiröz",
    image: "/hizli-tuketilen-iliskiler.jpeg",
    excerpt: "Günümüzde ilişkiler geçmişe kıyasla daha hızlı başlayıp daha kısa sürede sona erebiliyor. Bireyler, ilişkilerinde karşılaştıkları zorluklar karşısında ayrılığı daha kolay bir seçenek olarak değerlendirebiliyor...",
    filePath: "./blog-posts/hizli-tuketilen-iliskiler.js",
  },
  "oyun-terapisi-nedir": {
    id: 3,
    slug: "oyun-terapisi-nedir",
    title: "Oyun Terapisi Nedir? Çocukların Duygularını İfade Etme ve İyileşme Yolculuğu",
    date: "20 Şubat 2025",
    author: "Yağmur Demiröz",
    image: "/oyun-terapisi.jpeg",
    excerpt: "Çocuklar duygularını en iyi nasıl anlatır? Kelimelerle değil, oyunlarla...",
    filePath: "./blog-posts/oyun-terapisi-nedir.js",
  },
  "okul-basarisi-ve-cocuk-psikolojisi": {
    id: 2,
    slug: "okul-basarisi-ve-cocuk-psikolojisi",
    title: "Okul Başarısı ve Çocuk Psikolojisi: Çocukların Eğitim Sürecinde Psikolojik Destek",
    date: "12 Şubat 2025",
    author: "Yağmur Demiröz",
    image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&auto=format&fit=crop",
    excerpt: "Ebeveynlerin en çok kaygılandığı konulardan biri, çocuklarının okul başarısıdır. Okulda başarılı olmak, sadece akademik bilgiyle ilgili değil...",
    filePath: "./blog-posts/okul-basarisi-ve-cocuk-psikolojisi.js",
  },
  "cocuklarda-dikkat-eksikligi-ve-hiperaktivite-bozuklugu-dehb": {
    id: 1,
    slug: "cocuklarda-dikkat-eksikligi-ve-hiperaktivite-bozuklugu-dehb",
    title: "Çocuklarda Dikkat Eksikliği ve Hiperaktivite Bozukluğu (DEHB): Belirtileri ve Desteklemenin Yolları",
    date: "7 Şubat 2025",
    author: "Yağmur Demiröz",
    image: "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=800&auto=format&fit=crop",
    excerpt: "Çocukluk döneminde zaman zaman gözlemlenen dikkat eksiklikleri, hiperaktivite veya impulsif davranışlar gibi durumlar, DEHB işareti olabilir...",
    filePath: "./blog-posts/cocuklarda-dikkat-eksikligi-ve-hiperaktivite-bozuklugu-dehb.js",
  },
};
